<template>
  <DSInlineToken
    v-for="(token, index) in props.tokens"
    :id="tokenChipId(props.idPrefix, index)"
    :key="token.id ?? index"
    :class="[DS_TOKEN_INPUT_CLASSES.Chip, { [DS_TOKEN_INPUT_CLASSES.ChipGroupEnd]: endsGroup(index) }]"
    :style="{ order: 2 * index + 1 }"
    :text="token.label ?? token.text"
    :variant="token.variant"
    :group-edge="token.groupEdge ?? groupEdges[index]"
    :prefix-icon="token.prefixIcon"
    :avatar-url="token.avatarUrl"
    :flag="token.flag"
    :description="token.description"
    :selected="props.selectedIndex === index"
    :disabled="props.disabled"
    @mousedown.prevent
    @click="emit('open', index, $event)"
  />
</template>

<script setup lang="ts">
import { toRef } from "vue";
import DSInlineToken from "@/src/design_system/data_display/inline_token/components/DSInlineToken.vue";
import { DS_INLINE_TOKEN_GROUP_EDGE } from "@/src/design_system/data_display/inline_token/types/props";
import { DS_TOKEN_INPUT_CLASSES } from "@/src/design_system/form_elements/token_input/constants/classes";
import { useTokenInputGroups } from "@/src/design_system/form_elements/token_input/composables/useTokenInputGroups";
import type { DSInputToken } from "@/src/design_system/form_elements/token_input/types";
import { tokenChipId } from "@/src/design_system/form_elements/token_input/utils/tokenChipId";

defineOptions({ inheritAttrs: false });

const props = defineProps<{
  tokens: DSInputToken[];
  idPrefix: string;
  selectedIndex: number | null;
  disabled: boolean;
}>();

const emit = defineEmits<{
  (e: "open", index: number, event: MouseEvent): void;
}>();

const groupEdges = useTokenInputGroups(toRef(props, "tokens"));

const endsGroup = (index: number): boolean =>
  groupEdges.value[index] === DS_INLINE_TOKEN_GROUP_EDGE.Solo ||
  groupEdges.value[index] === DS_INLINE_TOKEN_GROUP_EDGE.End;
</script>
